import { useEffect, useState } from "react";

import { detectPlatform, type Platform } from "./platformDetector";

export const usePlatformDetector = (): Platform => {
  const [platform, setPlatform] = useState<Platform>("web");

  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);

  return platform;
};
